export default process.env.REACT_APP_HERE_MAP_KEY;